import Grid from '@material-ui/core/Grid';
import React from 'react';
import { ChildrenProps } from '../interfaces/childrenProps';
import { StyledAlert } from '../styles/alert';

/** Props for Alert Component */
interface AlertProps extends ChildrenProps {
  show: boolean | undefined;
  state?: 'success' | 'info' | 'warning' | 'error';
  gridClassName?: string;
}

/** Alert Component */
const Alert = ({ show, children, state = 'info', gridClassName = '' }: AlertProps): JSX.Element => {
  return (
    <>
      {show && (
        <Grid item xs={12} className={gridClassName}>
          <StyledAlert icon={false} severity={state} variant="outlined">
            {children}
          </StyledAlert>
        </Grid>
      )}
    </>
  );
};

export default Alert;
